import { useMutation } from 'react-query';
import { QueryOptions, useResourceController } from 'src/common/hooks';
import { client } from 'src/utils/api-client';
import {
  EmployeeSurveyResponseOutSchema,
  EmployeeSurveyResponseFilterSchema,
} from './types';

export const useEmployeeSurveyResponses = (
  params: EmployeeSurveyResponseFilterSchema = {},
  queryOptions: QueryOptions<any> = {}
) => {
  return useResourceController<undefined, EmployeeSurveyResponseOutSchema>(
    '/web/ghg/employee-surveys/responses',
    ['employee-survey-responses', params],
    params,
    queryOptions,
    ['GET', 'PUT', 'DELETE'] // Only GET methods allowed as requested
  );
};

export type EmployeeSurveyCategory =
  'commute' | 'remote' | 'business' | 'hotel';

export type EmployeeSurveyCopyPeriodPayload = {
  organization_id: number;
  source_period: string;
  target_period: string;
  categories?: EmployeeSurveyCategory[] | null;
  allow_existing_target?: boolean;
};

export type EmployeeSurveyCopyPeriodResult = {
  copied: number;
  skipped_existing: number;
  skipped_participant_ids: string[];
  target_rows_before: number;
  target_rows_after: number;
  cross_year: boolean;
};

// No automatic toasts - callers handle success/error feedback themselves.
export const useCopyEmployeeSurveyPeriod = () =>
  useMutation((data: EmployeeSurveyCopyPeriodPayload) =>
    client
      .post<EmployeeSurveyCopyPeriodResult>(
        '/web/ghg/employee-surveys/copy-period',
        data
      )
      .then((res) => res.data)
  );

export type EmployeeSurveyBulkDeletePayload = {
  organization_id: number;
  ids: number[];
};

export type EmployeeSurveyBulkDeleteResult = {
  deleted: number;
};

// No automatic toasts - callers handle success/error feedback themselves.
export const useBulkDeleteEmployeeSurveyResponses = () =>
  useMutation((data: EmployeeSurveyBulkDeletePayload) =>
    client
      .post<EmployeeSurveyBulkDeleteResult>(
        '/web/ghg/employee-surveys/bulk-delete-responses',
        data
      )
      .then((res) => res.data)
  );
